// The editable definitions behind a page's measured boxes. Definitions always come from the
// published layout; pending edits are projected here even when the displayed preview is older.
export const elementAddress = (layout, id) => `layout/${layout}/${id}/element`;

export function layoutDefinitions(definitions, layout, pending) {
  const result = structuredClone(definitions);
  const prefix = `layout/${layout}/`;
  for (const edit of pending.filter(entry => entry.address.startsWith(prefix))) {
    const [id, prop] = edit.address.slice(prefix.length).split('/');
    const index = result.findIndex(item => item.id === id);
    if (prop === 'element') {
      if (edit.value === null) { if (index >= 0) result.splice(index, 1); }
      else if (index >= 0) result[index] = structuredClone(edit.value);
      else result.push(structuredClone(edit.value));
    } else if (index >= 0) {
      const keys = prop.split('.'), key = keys.pop();
      let holder = result[index];
      for (const name of keys) holder = holder[name];
      holder[key] = edit.value;
    }
  }
  return result;
}

export function elementValues(definition, rules) {
  const result = {};
  for (const prop of Object.keys(rules)) {
    let value = definition;
    for (const name of prop.split('.')) value = value?.[name];
    if (value !== undefined) result[prop] = value;
  }
  return result;
}

export function editableElements(definitions, rendered, layout, kinds, pending) {
  return layoutDefinitions(definitions, layout, pending).map(definition => {
    const values = elementValues(definition, kinds[definition.kind] ?? {});
    const drawn = rendered.find(item => item.id === definition.id);
    // New text has an explicit height; measured text keeps the height of its last render.
    const box = definition.kind === 'art' ? [definition.x, definition.y, definition.w, definition.h]
      : [definition.x, definition.y, definition.w, definition.height ?? definition.size * 1.5];
    return { ...(drawn ?? { ...values, box }), id: definition.id, kind: definition.kind, name: definition.name,
      layout, definition, currentValues: values };
  });
}
